import React from 'react'

// bootstrap
import {
    OverlayTrigger,
} from 'react-bootstrap'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// tooltips
import { renderTooltipClose } from 'utlis/helpers/Tooltips/CommonTooltips'

export default function EditVariantImageModal(props) {
    // states
    const {
        closeModal,
        modalData,

        handleDeleteVariantImageChange
    } = props

    return (
        <div className="app-modal-content modal_edit-variant-img">
            {/* close icon */}
            <div className="close-icon">
                <OverlayTrigger
                    placement={"bottom"}
                    overlay={renderTooltipClose}
                >
                    <button
                        className="st-round-btn st-btn-transparent st-btn-sm d-flex align-items-center justify-content-center"
                        onClick={closeModal}
                    >
                        <FeatherIcon
                            icon="x"
                            size="17"
                            className="icon st-text-primary" />
                    </button>
                </OverlayTrigger>
            </div>


            <div className="change-variant-image-container">
                {/* heading */}
                {/* <div className="app-modal-title-wrapper mb-3 mb-lg-4">
                    <p className="app-modal-title text-capitalize">Change Image</p>
                </div> */}

                <div className="change-variant-image position-relative">
                    {/* img */}
                    <div className="img">
                        <img src={modalData.largeImgSrc} alt="" className="img-fluid img-fluid-height" />
                    </div>

                    {/* btns */}
                    <div className="btns position-absolute">
                        <div className="options-inner d-flex">
                            <a href="/"
                                className="delete st-round-btn st-btn-sm d-flex align-items-center justify-content-center"
                                title="Delete"
                                onClick={ev => handleDeleteVariantImageChange(ev, modalData.id)}>
                                <FeatherIcon
                                    icon="trash-2"
                                    size="14"
                                    className="icon"
                                />
                            </a>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    )
}
